import type { EventCard } from '../api/types';
import { formatEventDate, formatGoing, formatIdr, formatSpotsLeft } from '../format';

interface Props {
  event: EventCard;
  onOpen: (id: number) => void;
}

export function EventCardView({ event, onOpen }: Props) {
  const going = event.my_status && event.my_status !== 'cancelled';

  return (
    <button className="card card--tappable" onClick={() => onOpen(event.id)}>
      {event.poster_url && (
        <img className="card__poster" src={event.poster_url} alt="" loading="lazy" />
      )}

      <div className="card__body">
        <div className="card__meta">
          <span className="chip">{event.category.name}</span>
          {event.visibility === 'club' && <span className="chip chip--club">Клуб</span>}
          {going && <span className="chip chip--going">Вы идёте</span>}
        </div>

        <h3 className="card__title">{event.title}</h3>

        <div className="card__line">{formatEventDate(event.starts_at)}</div>
        {event.location && <div className="card__line muted">{event.location}</div>}

        <div className="card__footer">
          <span className="card__price">{formatIdr(event.price_idr)}</span>
          <span className="muted">
            {/* Число участников важнее числа мест: ради людей и приходят. */}
            {event.going_count > 0 ? formatGoing(event.going_count) : 'Пока никого'}
            {event.spots_left !== null && event.spots_left <= 5 && (
              <span className="urgent"> · {formatSpotsLeft(event.spots_left)}</span>
            )}
          </span>
        </div>
      </div>
    </button>
  );
}
